import StateAddress from "./StateAddress";

 

export default class Address {

    Id: string;
    AddressName: string | undefined;;
    NumberAddress: string | undefined;
    Complement: string | undefined;
    City: string | undefined;
    State: string | undefined;
    StateAddress: StateAddress | undefined;
    Neighborhood: string | undefined;
    CEP: string | undefined;
    

    constructor(id: string, addressName: string) {
        this.Id = id;
        this.AddressName = addressName;
    }

    static NewInstance() {
        return new Address("", "");
    }
}